import { Paper, Box, CircularProgress } from '@mui/material';
import classes from './ccf-directory.module.scss';
import { useEffect, useState } from 'react';
import {
  Agent,
  fetchAgentContacts,
  selectAgentList,
  selectDropDownQueryValue,
  selectLoadingStatus,
  selectSearchBoxQueryValue,
  selectSkillsValue,
} from './+state/ccf-directory.slice';
import { useDispatch, useSelector } from 'react-redux';
import { CcfDirectorySelect } from './ccf-directory-select/ccf-directory-select';
import { CcfDirectorySearch } from './ccf-directory-search/ccf-directory-search';
import DirectoryItem from './ccf-directory-item/ccf-directory-item';
import { CcfTypography } from '@nice-ccf/ui-controls';
import CcfOutboundOptions from '../ccf-outbound-options/ccf-outbound-options';
import CcfDirectoryItemContact from './ccf-directory-item-contact/ccf-directory-item-contact';
import { activeContactSelector } from '../ccf-inbox/ccf-inbox.slice';

/* eslint-disable-next-line */
export interface CcfDirectoryProps {
  isFullView: boolean;
}

/**
 * Component for ccf directory
 * @param props - CcfDirectoryProps
 * @example - <CcfDirectory />
 * @returns
 */
export function CcfDirectory(props: CcfDirectoryProps) {
  const dispatch = useDispatch();

  const users = useSelector(selectAgentList);
  const elevatedContact = useSelector(activeContactSelector);
  const loading = useSelector(selectLoadingStatus);
  const [callTypeSelected, updateCallTypeSelcted] = useState(false);
  const searchBoxQuery = useSelector(selectSearchBoxQueryValue);
  const numberSkills = useSelector(selectSkillsValue);
  const [searchContact, updateSearchContact] = useState<string>('');
  const selectedDropDownValue = useSelector(selectDropDownQueryValue);

  useEffect(() => {
    if (users.length === 0 && !searchBoxQuery) {
      if (selectedDropDownValue !== 'people') {
        dispatch(fetchAgentContacts());
      }
    }
  }, []);

  useEffect(() => {
    //re rendering component
  }, [selectedDropDownValue]);

  /**
   * Function to update call type
   * @param trigger - boolean
   * @example - outboundCallOptionSelcted(true)
   */
  const outboundCallOptionSelcted = (trigger: boolean) => {
    updateCallTypeSelcted(trigger);
  };

  return (
    <Paper square elevation={0} classes={{ root: classes.directoryContainer }}>
      <CcfDirectorySearch updateSearchQuery={updateSearchContact} />
      <CcfDirectorySelect />
      <Paper
        square
        component={'ul'}
        classes={{ root: classes.directory }}
        elevation={0}
      >
        {!callTypeSelected ? (
          <>
            {!loading &&
              selectedDropDownValue !== 'people' &&
              users.map((user) => (
                <DirectoryItem key={user.id} user={user as Agent} isHovering={false} />
              ))}
            {!loading && selectedDropDownValue === 'people' && (
              <CcfDirectoryItemContact
                elevatedContact={elevatedContact as any}
                isHovering={false}
              />
            )}
            {!loading && users.length === 0 && (
              <CcfTypography
                translationKey="noMatchesFound"
                classes={{ root: classes.noAgentFoundTypography }}
              />
            )}
            {loading && (
              <Box textAlign="center" mt={3} width="100%">
                <CircularProgress size={20} />
              </Box>
            )}
          </>
        ) : null}
        {!loading && users.length === 0 && (
          <CcfOutboundOptions
            selectCallType={outboundCallOptionSelcted}
            number={searchContact}
            skills={numberSkills?.[searchContact] || []}
          />
        )}
      </Paper>
    </Paper>
  );
}

export default CcfDirectory;
